import React, { useState, useRef } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  Center,
  ColorInput,
  Text,
  Select,
  Checkbox,
} from "@mantine/core";
import { Dropzone } from "@mantine/dropzone";
import { IconPhoto, IconUpload, IconVideo } from "@tabler/icons-react";
import classes from "./add.module.css";
import { RowDataSplashScreen } from "./types";

interface AddSplashScreenModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddSplashScreen: (newData: RowDataSplashScreen) => void;
}

const AddSplashScreenModal: React.FC<AddSplashScreenModalProps> = ({
  isOpen,
  onClose,
  onAddSplashScreen,
}) => {
  const [newSplashScreen, setSplashScreen] = useState<RowDataSplashScreen>({
    id: "",
    title: "",
    img_url: "",
    isVisible: true,
    action: "Edit",
  });
  const imageDropzoneRef = useRef<() => void>(null);

  const handleImageUpload = (files: File[]) => {
    const file = files[0];
    if (file) {
        setSplashScreen({ ...newSplashScreen, img_url: file });
    }
  };

  const handleAddSplashScreen = () => {
    // Check if any required fields are empty
    if (!newSplashScreen.title || !newSplashScreen.img_url) {
      alert("Please fill in all the required fields");
      return;
    }

    onAddSplashScreen(newSplashScreen);

    // Clear inputs and reset state
    setSplashScreen({
      id: "",
      title: "",
      img_url: "",
      isVisible: true,
      action: "Edit",
    });

    onClose();
  };

  const handleClose = () => {
    // Clear inputs and reset state
    setSplashScreen({
      id: "",
      title: "",
      img_url: "",
      isVisible: true,
      action: "Edit",
    });

    // Call the onClose function
    onClose();
  };

  return (
    <Modal
      style={{ zIndex: "100" }}
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          New Splash Screen
        </div>
      }
      opened={isOpen}
      onClose={handleClose}
    >
      <TextInput
        label="Title"
        placeholder="Input title"
        mb="sm"
        maxLength={255}
        value={newSplashScreen.title}
        onChange={(event) =>
            setSplashScreen({ ...newSplashScreen, title: event.currentTarget.value })
        }
      />

      <Text className={classes.Text}>
        Image <span className={classes.format}>(.jpg, .png)</span>
      </Text>
      <Dropzone
        onDrop={handleImageUpload}
        accept={["image/*"]}
        openRef={imageDropzoneRef}
      >
        <div className={classes.imageContainer}>
          {newSplashScreen.img_url ? (
            <img
              src={URL.createObjectURL(newSplashScreen.img_url)}
              alt="Image"
              className={classes.imageSize}
            />
          ) : (
            <p>
              <IconPhoto />
            </p>
          )}
        </div>
      </Dropzone>
      <Group>
        <Button
          onClick={() => imageDropzoneRef.current?.()}
          className={classes.imageButton}
        >
          <IconPhoto />
          Upload Image
        </Button>
      </Group>

      <Checkbox
      label="Show Splash Screen"
      checked={newSplashScreen.isVisible}
      onChange={(event) => setSplashScreen({ ...newSplashScreen, isVisible: event.currentTarget.checked})}
    />

      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonBack}>
          Back
        </Button>
        <Button onClick={handleAddSplashScreen} className={classes.buttonSubmit}>
          Submit
        </Button>
      </Group>
    </Modal>
  );
};

export default AddSplashScreenModal;
